/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  AttributeService,
  IAttributeMethods,
  IFeatureMethods,
  ValueService,
  FeatureService,
  IValueMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  GetTemplateCostumeTypesService,
  IGetTemplateCostumeTypesMethods,
} from "./components";

export type InventoryTemplatePageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IFeatureMethods &
  IGetTemplateCostumeTypesMethods &
  IAttributeMethods &
  IValueMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new FeatureService(),
    new GetTemplateCostumeTypesService(),
    new ValueService(),
    new AttributeService(),
  ];
};

export const getAgent = () => {
  return createAgent<InventoryTemplatePageAgent>({
    plugins: getPlugins(),
  });
};
